import React, { FC } from 'react'

import { Chips } from '@interco/inter-ui/components/Chips'

import { Chip, ChipsContainer } from '../styles/ChipFilter.styles'
import { TChipFilterView } from '../types/ChipFilter.types'

export const ChipFilterView: FC<TChipFilterView> = ({ selectedChip, options, onClick }) => (
  <ChipsContainer>
    {options.map((option) => (
      <Chip key={option}>
        <Chips
          isActive={option === selectedChip}
          label={option}
          mode="normal"
          variant="caption-2"
          onClick={() => onClick(option)}
        />
      </Chip>
    ))}
  </ChipsContainer>
)
